module.exports = __webpack_public_path__ + "906f220535af2b0553a8f1341f201196.jpg";